<template>
    <Header
        :isMobileMenuOpen="isMobileMenuOpen"
        @toggle-mobile-menu="toggleMobileMenuOpen"
    />
    <main>
        <router-view v-slot="{ Component }">
            <transition name="route-fade-scale" mode="out-in">
                <component :is="Component" />
            </transition>
        </router-view>
    </main>
    <Footer />
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'

import Header from '@/components/Common/Header.vue'
import Footer from '@/components/Common/Footer.vue'

export default defineComponent({
    name: 'App',
    components: {
        Header,
        Footer,
    },
    setup() {
        const isMobileMenuOpen = ref(false)

        const toggleMobileMenuOpen = () => {
            isMobileMenuOpen.value = !isMobileMenuOpen.value
        }

        return {
            isMobileMenuOpen,
            toggleMobileMenuOpen,
        }
    },
})
</script>

<style lang="scss">
@import './styles/variables';
@import './styles/mixins';
@import './styles/config';

main {
    position: relative;
    margin: 0;
    padding: 0;
    width: 100%;
    height: auto;
    overflow-x: hidden;
}

.route-fade-scale-enter-active,
.route-fade-scale-leave-active {
    transition: opacity 0.2s ease-in-out, transform 0.3s ease;
}

.route-fade-scale-enter-from {
    opacity: 0;
    transform: translateY(-4vh);
}

.route-fade-scale-leave-to {
    opacity: 0;
    transform: translateY(4vh);
}

.route-fade-scale-enter-to {
    opacity: 1;
    transform: translateY(0);
}

.route-fade-scale-leave-from {
    opacity: 1;
    transform: translateY(0);
}
</style>
